<template>
  <transition name="sv-slide">
    <div v-if="visible" class="axg-overlay" @click.self="$emit('close')">
      <div class="axg-panel">
        <!-- Header -->
        <div class="axg-panel__header">
          <div class="axg-panel__title">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <rect
                x="3"
                y="4"
                width="18"
                height="18"
                rx="2"
                stroke="#0284C7"
                stroke-width="2"
                fill="none"
              />
              <line
                x1="3"
                y1="9"
                x2="21"
                y2="9"
                stroke="#0284C7"
                stroke-width="2"
              />
              <line
                x1="8"
                y1="2"
                x2="8"
                y2="6"
                stroke="#0284C7"
                stroke-width="2"
                stroke-linecap="round"
              />
              <line
                x1="16"
                y1="2"
                x2="16"
                y2="6"
                stroke="#0284C7"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            Todas las reglas de retención
          </div>
          <button class="axg-panel__close" @click="$emit('close')">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <line
                x1="18"
                y1="6"
                x2="6"
                y2="18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
              <line
                x1="6"
                y1="6"
                x2="18"
                y2="18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>

        <!-- Body -->
        <div class="axg-panel__body" v-loading="loading">
          <!-- Tabla de reglas -->
          <el-table
            v-if="localRules.length > 0"
            :data="localRules"
            size="small"
            class="axg-table"
            max-height="360"
          >
            <el-table-column
              prop="recorderIdentifier"
              label="Cámara"
              min-width="140"
              sortable
            />
            <el-table-column
              prop="streamingEventId"
              label="Evento"
              min-width="120"
              sortable
            />
            <el-table-column label="Días" width="120">
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.daysToKeep"
                  :min="1"
                  :max="999"
                  size="mini"
                  :disabled="editingKey !== rowKey(row)"
                  style="width: 90px"
                />
              </template>
            </el-table-column>
            <el-table-column label="Activa" width="80">
              <template slot-scope="{ row }">
                <el-switch
                  v-model="row.isActive"
                  :disabled="editingKey !== rowKey(row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="" width="160">
              <template slot-scope="{ row }">
                <div class="axg-row-actions">
                  <button
                    class="axr-btn axr-btn--small"
                    :class="
                      editingKey === rowKey(row)
                        ? 'axr-btn--primary'
                        : 'axr-btn--secondary'
                    "
                    :disabled="savingKey === rowKey(row)"
                    @click="onToggleEdit(row)"
                  >
                    <template v-if="editingKey === rowKey(row)">
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <polyline
                          points="20,6 9,17 4,12"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          fill="none"
                        />
                      </svg>
                      Guardar
                    </template>
                    <template v-else>
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          fill="none"
                        />
                        <path
                          d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          fill="none"
                        />
                      </svg>
                      Editar
                    </template>
                  </button>
                  <button
                    class="axr-rule__delete"
                    :disabled="savingKey === rowKey(row)"
                    @click="onDelete(row)"
                  >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                      <polyline
                        points="3,6 5,6 21,6"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        d="M19 6l-1 14H6L5 6"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        d="M10 11v6M14 11v6"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                      <path
                        d="M9 6V4h6v2"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </button>
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div v-else-if="!loading" class="axr-empty">
            No hay ninguna regla creada todavía.
          </div>

          <!-- Nueva regla -->
          <div class="axr-new">
            <div class="axr-new__title">Nueva regla</div>
            <div class="axr-new__row">
              <el-select
                v-model="newRule.recorderIdentifier"
                placeholder="Cámara"
                size="small"
                filterable
                class="axg-new__camera"
                @change="newRule.streamingEventId = ''"
              >
                <el-option
                  v-for="cam in cameras"
                  :key="cam"
                  :label="cam"
                  :value="cam"
                />
              </el-select>
              <el-select
                v-model="newRule.streamingEventId"
                placeholder="Evento"
                size="small"
                class="axr-new__select"
                :disabled="!newRule.recorderIdentifier"
              >
                <el-option
                  v-for="ev in availableEventsForNew"
                  :key="ev.id"
                  :label="ev.name || ev.id"
                  :value="ev.id"
                />
              </el-select>
              <el-input-number
                v-model="newRule.daysToKeep"
                :min="1"
                :max="999"
                size="small"
                class="axr-new__days"
              />
              <span class="axr-rule__days-label">días</span>
              <button
                class="axr-btn axr-btn--primary"
                :disabled="
                  !newRule.recorderIdentifier ||
                  !newRule.streamingEventId ||
                  creating
                "
                @click="onCreate"
              >
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
                  <line
                    x1="12"
                    y1="5"
                    x2="12"
                    y2="19"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <line
                    x1="5"
                    y1="12"
                    x2="19"
                    y2="12"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
                Añadir
              </button>
            </div>
            <div
              v-if="
                newRule.recorderIdentifier && availableEventsForNew.length === 0
              "
              class="axr-new__hint"
            >
              Ya existe una regla para todos los eventos disponibles en esta
              cámara.
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="axg-panel__footer">
          <span class="axg-panel__count"
            >{{ localRules.length }} reglas en total</span
          >
          <button class="axr-btn axr-btn--secondary" @click="$emit('close')">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  loadRetentionRules,
  createRetentionRule,
  deleteRetentionRule,
  updateRetentionDays,
  updateRetentionActive,
  loadAxisDiskStatus,
} from "@/services/axis.api";
import { getStreamingEvents } from "@/services/streamingEvent.api";

export default {
  name: "AxisRetentionGlobalDialog",
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      localRules: [],
      availableEvents: [],
      cameras: [],
      loading: false,
      editingKey: null,
      savingKey: null,
      creating: false,
      newRule: { recorderIdentifier: "", streamingEventId: "", daysToKeep: 30 },
    };
  },
  computed: {
    availableEventsForNew() {
      if (!this.newRule.recorderIdentifier) return [];
      const usedEvents = this.localRules
        .filter((r) => r.recorderIdentifier === this.newRule.recorderIdentifier)
        .map((r) => r.streamingEventId);
      return this.availableEvents.filter((ev) => !usedEvents.includes(ev.id));
    },
  },
  watch: {
    visible(val) {
      if (val) this.loadData();
    },
  },
  methods: {
    rowKey(row) {
      return row.recorderIdentifier + "::" + row.streamingEventId;
    },
    async loadData() {
      this.loading = true;
      this.editingKey = null;

      try {
        const rules = await loadRetentionRules();
        this.localRules = rules.map((r) => ({ ...r }));
      } catch (e) {
        console.error("Error cargando reglas de retención:", e);
        this.$message.error("Error al cargar las reglas de retención.");
      }

      try {
        this.availableEvents = await getStreamingEvents();
      } catch (e) {
        console.error("Error cargando eventos disponibles:", e);
        this.$message.error("Error al cargar los eventos disponibles.");
      }

      try {
        const diskStatus = await loadAxisDiskStatus();
        this.cameras = diskStatus
          .map((c) => c.recorderIdentifier)
          .sort((a, b) => a.localeCompare(b));
      } catch (e) {
        console.error("Error cargando listado de cámaras:", e);
        this.$message.error("Error al cargar el listado de cámaras.");
      }

      this.loading = false;
    },
    onToggleEdit(row) {
      const key = this.rowKey(row);
      if (this.editingKey === key) {
        this.onSave(row);
      } else {
        this.editingKey = key;
      }
    },
    async onSave(row) {
      const key = this.rowKey(row);
      this.savingKey = key;
      try {
        await Promise.all([
          updateRetentionDays(
            row.recorderIdentifier,
            row.streamingEventId,
            row.daysToKeep
          ),
          updateRetentionActive(
            row.recorderIdentifier,
            row.streamingEventId,
            row.isActive
          ),
        ]);
        this.$message.success("Regla guardada.");
        this.editingKey = null;
      } catch (e) {
        console.error("Error guardando regla:", e);
        this.$message.error("Error al guardar la regla.");
      } finally {
        this.savingKey = null;
      }
    },
    async onDelete(row) {
      try {
        await this.$confirm(
          `¿Eliminar la regla "${row.streamingEventId}" de ${row.recorderIdentifier}?`,
          "Confirmar",
          {
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        );
      } catch {
        return;
      }
      const key = this.rowKey(row);
      this.savingKey = key;
      try {
        await deleteRetentionRule(row.recorderIdentifier, row.streamingEventId);
        this.localRules = this.localRules.filter((r) => this.rowKey(r) !== key);
        if (this.editingKey === key) this.editingKey = null;
        this.$message.success("Regla eliminada.");
      } catch (e) {
        console.error("Error eliminando regla:", e);
        this.$message.error("Error al eliminar la regla.");
      } finally {
        this.savingKey = null;
      }
    },
    async onCreate() {
      this.creating = true;
      try {
        await createRetentionRule({
          recorderIdentifier: this.newRule.recorderIdentifier,
          streamingEventId: this.newRule.streamingEventId,
          daysToKeep: this.newRule.daysToKeep,
          isActive: true,
        });
        this.localRules.push({
          recorderIdentifier: this.newRule.recorderIdentifier,
          streamingEventId: this.newRule.streamingEventId,
          daysToKeep: this.newRule.daysToKeep,
          isActive: true,
        });
        this.newRule = {
          recorderIdentifier: "",
          streamingEventId: "",
          daysToKeep: 30,
        };
        this.$message.success("Regla creada.");
      } catch (e) {
        console.error("Error creando regla:", e);
        if (e.response && e.response.status === 409) {
          this.$message.error(
            "Ya existe una regla para esta cámara y este evento."
          );
        } else {
          this.$message.error("Error al crear la regla.");
        }
      } finally {
        this.creating = false;
      }
    },
  },
};
</script>

<style>
.axg-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.axg-panel {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  width: 800px;
  max-width: 95vw;
  display: flex;
  flex-direction: column;
  animation: axrSlideUp 0.2s ease;
  max-height: 85vh;
}

.axg-panel__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 12px 12px 0 0;
  flex-shrink: 0;
}

.axg-panel__title {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  flex: 1;
}

.axg-panel__close {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  transition: border-color 0.15s, color 0.15s;
}
.axg-panel__close:hover {
  border-color: #94a3b8;
  color: #0f172a;
}

.axg-panel__body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.axg-table {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.axg-row-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.axg-new__camera {
  width: 180px;
}

.axg-panel__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 14px 20px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 0 0 12px 12px;
  flex-shrink: 0;
}

.axg-panel__count {
  font-size: 12px;
  color: #94a3b8;
}
</style>
